import React, { Component } from "react";
import { axiosPost } from "../../utils/AxiosApi";
import { URL, userRole, userRoleCode } from "../../utils/Constants";
import ModalWindow from "./../UI/ModalWindow";
import GranularPermissionModal from "./../Permissions/GranularPermissionModal";
import swal from "sweetalert";
import moment from "moment";
import ListStudentAttendanceDetails from "./ListStudentAttendanceDetails";
import _, { groupBy } from "lodash";
import { compareByYearLevelName } from "../../utils/Utils";
import { adToBS, adYearToBS, bsToAD, monthList } from "nepali-calander";

class AttendanceForStudent extends Component {
  state = {
    month: "",
    classrooms: [],
    classRoomName: "",
    yearLevelId: "",
    sectionId: "",
    students: [],
    // calendarDate: moment().format("YYYY-MM-DD"),
    calendarDate: "",
    selectedMonth:null,
    checkMonthSelected: true,
    showBtn: false,
    studentId: "",
    peopleId:localStorage.getItem("peopleId"),
    educationLevelDivisions: [],
    calendarMode : localStorage.getItem("calendar-mode") || "ad",
  };

  componentDidMount() {

     if(userRole.toString() == userRoleCode.roleStudent){
      this.getStudentDetail()
     } else if (userRole.toString() == userRoleCode.roleStudentContact) {
       this.getStudentByContactPeople();
     }
    this.getClassrooms();
    this.getYearLevels();
    this.getWeekDays();
    this.checkForCalendarEvents();
  }

   getStudentDetail =(peopleId) =>{
      let param = {
        peopleId:peopleId || this.state.peopleId
      }
      axiosPost(URL.getStudentDetail, param, (response) => {
        if (response.status === 200) {
          let data=response.data.data;
          this.setState({
            yearLevelId: data?.yearLevel?.id,
            sectionId :data?.classroom?.id,
            studentId:data.admission.id
          });
        }
      });
    }

  getStudentByContactPeople = () => {
    let param = {
      contactPeopleId: this.state.peopleId
    }
    axiosPost(URL.getStudentByContactPeople, param, (response) => {
      if (response.data.status == 200) {
        let data = response.data.data;
        this.setState({ students: data })
      }
    })
  }

  handleStudentChange = (e) => {
    let studentPeopleId = e.target.value;
    this.setState({ studentId: studentPeopleId })
  }

  getWeekDays = async () => {
    const weekDayPromise = new Promise((res, rej) => {
      axiosPost(
        URL.getWeekDaysByEduDiv,
        {
          educationLevelId: this.state.educationLevelId,
        },
        (response) => {
          if (response.status === 200) {
            res(response.data.data);
          }
        }
      );
    });
    const weekDays = await weekDayPromise;
    weekDays &&
      this.setState({
        weekDays: weekDays.map(({ id }) => id),
      });
    return weekDays.map(({ id }) => id);
  };

  //getCLassRoom
  getClassrooms = () => {
    let data = {
      yearLevelId: this.state.yearLevel,
    };
    axiosPost(URL.selectClassroom, data, (response) => {
      if (response.status === 200) {
        let classrooms = response.data.data;
        this.setState({
          classrooms,
        });
      }
    });
  };

  //getEnglishMonth Date
  getEnglishMonth = () => {
    const monthData = monthList();
    // wip the commented code below to get min and max date from the slected edcation level term.
    let educationLevelDivisions = [...this.state.educationLevelDivisions];
    const minStartDate = new Date(
      _.min(educationLevelDivisions.map(t => new Date(t.startDate)))
    );
    const maxEndDate = new Date(
      _.max(educationLevelDivisions.map(t => new Date(t.endDate)))
    );
    // const minStartDate = new Date(moment().startOf('year'));
    // const maxEndDate = new Date(moment().endOf('year'));
    const monthsBetween = this.getMonthsInAcademicYear(minStartDate, maxEndDate);
    const monthListData = monthsBetween.map(({ year, month }) => {
      const monthInfo = monthData.find(
        m => m.eng_month_index === month
      );
      const adDate = `${year}-${month < 10 ? '0' + month : month}-30`;
      const bsDate = adToBS(adDate); 
      let bsYear = bsDate.bs_y

      return {
        adYear: year,
        bsYear: bsYear,
        ...monthInfo
      };
    }).sort((a, b) => {
      if (this.state.calendarMode === "bs") {
        return (
          a.bsYear - b.bsYear ||
          a.nep_month_index - b.nep_month_index
        );
      }
      return (
        a.adYear - b.adYear ||
        a.eng_month_index - b.eng_month_index
      );
    });
    this.setState({
      month: monthListData,
    });
  };

  getOldStudentsData = (date) => {
    const params = {
      classroomId: this.state.cid,
      subjectId: this.state.selectedSubject,
      date,
    };

    this.setState({ attendanceLoading: true }, () => {
      if (this.state.cid != null) {
        axiosPost(
          URL.getAssignedStudents,
          params,
          (response) => {
            if (response.status === 200) {
              let students = response.data.data;
              let studentAttendances = [...this.state.studentAttendances];
              for (let index = 0; index < students.length; index++) {
                studentAttendances.push({
                  yearLevelId: this.state.yid,
                  classroomId: this.state.cid,
                  admissionId: students[index].admissionId,
                  isPresent: students[index].isPresent || false,
                  remarks: "",
                  studentName: students[index].people.name,
                });
              }
              this.setState(
                {
                  students,
                  studentAttendances,
                },
                () => {
                  axiosPost(
                    URL.getStudentsAttendance,
                    params,
                    (response) => {
                      if (response.status == 200) {
                        let studentAttendents = [...response.data.data];
                        let studentAttendances = [
                          ...this.state.studentAttendances,
                        ];
                        studentAttendents.forEach((attendent) => {
                          const index = this.state.studentAttendances.findIndex(
                            (student) =>
                              student.admissionId === attendent.admissionId
                          );
                          if (index !== -1) {
                            studentAttendances[index].isPresent =
                              attendent.isPresent || false;
                          }
                        });
                        this.setState({
                          studentAttendances,
                          attendanceLoading: false,
                        });
                      }
                    },
                    (err) => {
                      this.setState({ attendanceLoading: false });
                    }
                  );
                }
              );
            }
          },
          (err) => {
            this.setState({ attendanceLoading: false });
          }
        );
      } else {
        swal("Select both yearLevel and Classroom");
      }
    });
  };

  getStudents = (cid, yid) => {
    this.setState({ attendanceLoading: true }, () => {});
    if (this.state.classRoomName != null) {
      let params = {
        classroomId: cid,
      };
      axiosPost(
        URL.getAssignedStudents,
        params,
        (response) => {
          if (response.status === 200) {
            let students = response.data.data;
            let studentAttendances = [...this.state.studentAttendances];
            for (let index = 0; index < students.length; index++) {
              studentAttendances.push({
                yearLevelId: yid,
                classroomId: cid,
                admissionId: students[index].admissionId,
                isPresent: students[index].isPresent || false,
                remarks: "",
                studentName: students[index].people.name,
              });
            }
            this.setState({
              students,
              studentAttendances,
              attendanceLoading: false,
            });
          }
        },
        (err) => {
          this.setState({ attendanceLoading: false });
        }
      );
    } else {
      swal("Select both yearLevel and Classroom");
    }
  };

  getStudentsInClassroom = () => {
    let data = {
      yearLevelId: this.state.yid,
      classroomId: this.state.cid,
    };
    axiosPost(URL.getAssignedStudents, data, (response) => {
      if (response.status === 200) {
        this.setState({
          students: response.data.data,
        });
      }
    });
  };

  getYearLevels = () => {
    axiosPost(
      URL.getYearLevelByEducationLevel,
      {
        educationLevelId: this.state.educationlevelId,
      },
      (response) => {
        if (response.status === 200) {
          this.setState({ yearLevels: response.data.data });
        }
      }
    );
  };

  getClassroomSubjects = (cid, yid) => {
    var data = {
      classroomId: cid,
      yearLevelId: yid,
    };
    axiosPost(URL.getSubjectByClassroom, data, (response) => {
      if (response.data.status === 200) {
        const data = response.data.data;
        const filterDuplicateOne =
          data &&
          data.filter(
            (value, index, self) =>
              index ===
              self.findIndex((t) => t.id === value.id && t.name === value.name)
          );

        if (data.length > 0) {
          this.setState({ subjects: filterDuplicateOne });
        }
      }
    });
  };
  handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value }, () => {
      axiosPost(
        URL.getAdmissionDetailSummary,
        {
          classroomId: this.state.cid,
          yearLevelId: this.state.yid,
          admissionId: this.state.studentId,
          dateFrom: this.state.firstDayFormat,
          dateTo: this.state.lastDayFormat,
        },
        (response) => {
          if (response.status === 200) {
            const groupByDate = groupBy(response.data.data, (d) => d.studentName);
            this.setState({ studentData: groupByDate, showBtn: true });
          }
        }
      );
    });
  };

  handleClassroomSelect = (e) => {
    const target = e.target;
    const value = target.value.split(",");
    const name = target.name;
    const cid = value[0];
    const yid = value[1];
    //get selected classroom for its education level
    const classroom = this.state.classrooms.find((c) => c.id === parseInt(cid));
    this.setState(
      {
        [name]: value,
        studentAttendances: [],
        students: [],
        selectedSubject: null,
        subjects: [],
        cid,
        yid,
        educationLevelId: classroom && classroom.educationLevelId,
        checkedAll: false,
      },
      async () => {
        this.getClassroomSubjects(cid, yid);
        if (this.state.calendarDate) {
          this.getOldStudentsData(this.state.calendarDate);
          const weekDays = await this.getWeekDays();
          const weekDay = new Date(this.state.calendarDate).getUTCDay();
          const isHoliday = weekDays.findIndex((day) => day === weekDay);
          this.setState({ isHoliday: isHoliday === -1 ? true : false });
          if (isHoliday === -1) return;
          //check for holidays in calendar event as well
          const eventHoliday = await this.checkForCalendarEvents();
          this.setState({ isHoliday: eventHoliday ? true : false });
        } else {
          this.getStudents(cid, yid);
        }
        this.getEducationLevelDivisions();
      }
    );
  };

  checkForCalendarEvents = async () => {
    const calendarEventsPromise = new Promise((res, rej) => {
      axiosPost(
        URL.getEventsByEducationLevel,
        {
          educationLevelId: this.state.educationLevelId,
        },
        (response) => {
          if (response.status === 200) {
            res(response.data.data);
          }
        }
      );
    });
    const calendarEvents = await calendarEventsPromise;
    if (calendarEvents) {
      //return true if selected day is holiday event
      for (let i = 0; i < calendarEvents.length; i++) {
        if (calendarEvents[i].isHoliday) {
          let range = moment(this.state.calendarDate).isBetween(
            calendarEvents[i].start,
            calendarEvents[i].end,
            "days",
            "[]"
          );
          if (range) return true;
        }
      }
    }
    return false;
  };
  getEducationLevelDivisions = () => {
    axiosPost(
      URL.getEducationLevelDivisions,
      { educationLevelId: this.state.educationLevelId },
      (response) => {
        if (response.status === 200) {
          this.setState(
            { educationLevelDivisions: response.data.data }
          ,() =>{
            this.getEnglishMonth();
          });

        }
      }
    );
  };
  getMonthsInAcademicYear = (start, end) => {
    const result = [];

    let current = new Date(start);
    const last = new Date(end);

    // Normalize to first day of month
    current.setDate(1);
    last.setDate(1);

    while (current <= last) {
      result.push({
        year: current.getFullYear(),
        month: current.getMonth() + 1 // JS month → 1–12
      });

      current.setMonth(current.getMonth() + 1);
    }

    return result;
  }
  fetchSelectedMonth = (data) => {
    const mode = this.state.calendarMode;
    if (mode === "bs") {
      return {
        year: data.bsYear,
        month: data.monthName,
        monthIndex: data.nep_month_index,
        daysInMonth: data.totalDaysInBsMonth
      };
    }

    // Default AD
    return {
      year: data.adYear,
      month: data.ad_month,
      monthIndex: data.eng_month_index,
      daysInMonth: data.totalDaysInAdMonth
    };
  }

  handleMonthChange = (e) => {
    let copyOfMonthArr = [...this.state.month];
    let educationLevelDivisions = [...this.state.educationLevelDivisions];
    let found = copyOfMonthArr.find((el) => {
      return `${el.ad_month}:${el.adYear}` === e.target.value;
    });
    // const daysInSelectedMonth = new Date(year, month, 0).getDate();
    // const firstDay = new Date(year, month, 1);
    let firstDayFormat, lastDayFormat;
    if (this.state.calendarMode === "ad") {
      firstDayFormat = moment(`${found.adYear}-${found.eng_month_index}-01`).format("YYYY-MM-DD");
      lastDayFormat = moment(`${found.adYear}-${found.eng_month_index}-${found.totalDaysInAdMonth}`).format("YYYY-MM-DD");
    } else {
      const firstDay = bsToAD(found.bsYear, found.nep_month_index, 1);
      firstDayFormat = moment(`${firstDay.ad_y}-${firstDay.ad_m}-${firstDay.ad_d}`).format("YYYY-MM-DD");
      // const lastDay = new Date(year, month + 1, 0);
      const lastDay = bsToAD(found.bsYear, found.nep_month_index, found.totalDaysInBsMonth);
      lastDayFormat = moment(`${lastDay.ad_y}-${lastDay.ad_m}-${lastDay.ad_d}`).format("YYYY-MM-DD");
    }
    let selectedMonth = this.fetchSelectedMonth(found);
    this.setState(
      {
        firstDayFormat,
        lastDayFormat,
        selectedMonth: selectedMonth,
        checkMonthSelected: false,
      },

      () => {
        axiosPost(
          URL.getAdmissionDetailSummary,
          {
            classroomId: this.state.cid,
            yearLevelId: this.state.yid,
            admissionId: this.state.studentId,
            dateFrom: this.state.firstDayFormat,
            dateTo: this.state.lastDayFormat,
          },
          (response) => {
            if (response.status === 200) {
              const groupByDate = groupBy(response.data.data, (d) => d.studentName);
              this.setState({ studentData: groupByDate, showBtn: true });
            }
          }
        );
      }
    );
  };
  render() {
    return (
      <>
        <div
          className="tt-widgetContent-tab-holder"
          style={{ height: "79.5vh" }}
        >
          <div className="tt-newListBox container-fluid">
            <div className="tt-group-header">
              <div className="row">
                {userRole.toString() == userRoleCode.roleStudentContact ?
                  <div className="col-4">
                    <strong>Students</strong>
                    <select
                      className="form-control"
                      name="educationLevel"
                      value={this.state.studentId}
                      onChange={this.handleStudentChange}
                    >
                      <option value="" selected disabled>
                        Select student
                      </option>
                      {this.state.students.map((sl, idx) => {
                        return <option value={sl.admissionId}>{sl.name}</option>;
                      })}
                    </select>
                  </div> : null
                }
              { userRole.toString() != userRoleCode.roleStudent && userRole.toString() != userRoleCode.roleStudentContact &&
                <div className="col-md-4">
                  <label>Attendance For</label>
                  <select
                    name="classRoomName"
                    id="classRoomName"
                    value={this.state.classRoomName}
                    className="form-control"
                    onChange={this.handleClassroomSelect}
                  >
                    <option value="" disabled>
                      Select Classroom
                    </option>
                    {this.state.classrooms ? (
                      this.state.classrooms
                        .sort(compareByYearLevelName)
                        .map((classroom, idx) => (
                          <option
                            key={idx}
                            value={`${classroom.id},${classroom.yearLevelId}`}
                          >
                            {/* What if yearlevel name is inserted as number(like:1,2,..) */}
                            Class {classroom.yearLevelName}
                            {" - "}
                            {classroom.name}
                          </option>
                        ))
                    ) : (
                      <option value="null">No Classroom available</option>
                    )}
                  </select>
                </div>}

                <div className="col-md-4">
                  <label>Month</label>
                  <select
                    name="Month"
                    className="form-control"
                    onChange={this.handleMonthChange}
                  >
                    <option value="" disabled selected>
                      Select Month
                    </option>
                    {this.state.month ? (
                      this.state.month.map((classroom, idx) => (
                        <option key={idx} value={`${classroom.ad_month}:${classroom.adYear}`}>
                          {/* What if yearlevel name is inserted as number(like:1,2,..) */}
                          {this.state.calendarMode === "ad" ? classroom.ad_month : classroom.monthName}
                          {/* uncomment below to display month year incase of overlapping months */}
                          - {this.state.calendarMode === "ad" ? classroom.adYear : classroom.bsYear}
                        </option>
                      ))
                    ) : (
                      <option value="null">No Month available</option>
                    )}
                  </select>
                </div>
              </div>
            </div>

            <ListStudentAttendanceDetails
              // student={this.state.students?.find(
              //   (s) => s.admissionId == this.state.studentId
              // )}
              selectedMonth={this.state.selectedMonth}
              subjects={[]}
              // subjects={this.state.subjects ? this.state.subjects : []}
              studentAttendanceRecord={
                this.state.studentData ? this.state.studentData : []
              }
              showBtn={this.state.showBtn}
              classRoomName={this.state.classRoomName}
              classrooms={this.state.classrooms}
            />
          </div>
        </div>

        <ModalWindow
          modal={this.state.permissionModal}
          size="lg"
          id="tt-permissionModal"
          toggleModal={() => {
            this.setState({
              permissionModal: !this.state.permissionModal,
            });
          }}
          modalHeader={"Assign permission to user"}
          modalBody={
            <GranularPermissionModal
              widgetName="Attendance"
              moduleName="Student Attendance"
              header="Student Attendance"
              activityName="insert-attendance"
            />
          }
        ></ModalWindow>
      </>
    );
  }
}
export default AttendanceForStudent;
